import {PartialRecord} from '@helpers/types';

type TimeType = 'pageIndicator' | 'prepare';

export class Time {
  static singleton: Time;
  private _time: PartialRecord<TimeType, number> = {};

  static create() {
    if (Time.singleton) {
      return Time.singleton;
    }
    return (Time.singleton = new Time());
  }

  start(key: TimeType) {
    this._time[key] = new Date().getTime();
    return this._time[key];
  }

  getDuration(key: TimeType): number {
    const now = new Date().getTime();
    const time = this._time[key] || 0;
    return now - time;
  }
}
